import React from 'react'
import CreatorView from '../../components/creator/CreatorView'

const EditorOverviewPage = (props) => {
    return <CreatorView {...props} />
}

export default EditorOverviewPage
